import React, { createContext, useState, useEffect, useContext, ReactNode } from 'react';
import { authenticatedFetch } from './authService';
import { getUserContext } from './UserContext';
import { useLoading } from './LoadingContext';

// Define the types for your context data
interface BranchContextType {
  branchList: string[];
  selectedBranch: string;
  setSelectedBranch: (branch: string) => void;
}

// The type for the provider's props (which must include 'children')
interface BranchProviderProps {
  children: ReactNode;
}

// Create the BranchContext with a default value of empty branchList
const BranchContext = createContext<BranchContextType | undefined>(undefined);

// Create the provider component
export const BranchProvider: React.FC<BranchProviderProps> = ({ children }) => {
  const user = getUserContext()
  const {setLoading} = useLoading();
  const [branchList, setBranchList] = useState<string[]>([]);
  const [selectedBranch, setSelectedBranch] = useState(user?.branch === 'ALL' ? '' : (user?.branch || ''));

  // Fetch branch list and update state
  const getBranchList = async () => {
    setLoading(true);
    const response = await authenticatedFetch('/contact'); 
    const res = await response.json();
    const data= res.map((branch:any)=>branch.location)
    setBranchList(["ALL", ...data]); 
    setLoading(false);
  };

  useEffect(() => {
    getBranchList();  
  }, []);

  return (
    <BranchContext.Provider value={{ branchList,selectedBranch,setSelectedBranch }}>
      {children}
    </BranchContext.Provider>
  );
};

// Custom hook to consume the branchList
export const useBranchContext = (): BranchContextType => {
  const context = useContext(BranchContext);
  if (!context) {
    throw new Error('useBranchContext must be used within a BranchProvider');
  }
  return context;
};